export function formatDateLabel(value: string | undefined, locale: string): string {
  if (!value) {
    return "";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return new Intl.DateTimeFormat(locale, {
    year: "numeric",
    month: "short",
    day: "numeric"
  }).format(date);
}

export function formatTimeLabel(value: string | undefined, locale: string): string {
  if (!value) {
    return "";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return value;
  }
  return new Intl.DateTimeFormat(locale, {
    hour: "2-digit",
    minute: "2-digit"
  }).format(date);
}

export function todayInputValue(): string {
  const date = new Date();
  const offset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - offset * 60_000);
  return local.toISOString().slice(0, 10);
}

export function addDaysToDateInput(value: string, days: number): string {
  const date = parseDateInput(value);
  date.setUTCDate(date.getUTCDate() + days);
  return date.toISOString().slice(0, 10);
}

export function compareDateInputs(left: string, right: string): number {
  return parseDateInput(left).getTime() - parseDateInput(right).getTime();
}

export function isFutureDateInput(value: string, today = todayInputValue()): boolean {
  return compareDateInputs(value, today) > 0;
}

export function yesterdayInputValue(today = todayInputValue()): string {
  return addDaysToDateInput(today, -1);
}

export function normalizeApiLocalDate(value: string | undefined | null): string | undefined {
  if (!value) {
    return undefined;
  }
  const calendarDate = value.match(/^(\d{4}-\d{2}-\d{2})/);
  if (calendarDate) {
    return calendarDate[1];
  }
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return undefined;
  }
  return parsed.toISOString().slice(0, 10);
}

export function birthYearToDate(year: number): string {
  return `${year}-01-01`;
}

function parseDateInput(value: string): Date {
  return new Date(`${value}T00:00:00Z`);
}
